module.exports = __webpack_public_path__ + "static/media/company--bg1.cdd3c16e.jpg";